import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconAssetRecapVideoStyle0 = gravityIconIndividualCss;

const GravityIconAssetRecapVideo = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: 'af66144bc86f768dd508ac827a26d9f2cfdcfd81', color: this.color, size: this.size }, h("svg", { key: '37461fad4539c89fbb82f9eb160add08dbf6427f', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '2f5d26920b6615c3116728ccf04fb8724d572b34', d: "m11.08 10.58 2.62-2.056a.204.204 0 0 1 .3.192v4.172a.209.209 0 0 1-.3.183l-2.62-2.048v1.865a.209.209 0 0 1-.3.191l-2.662-2.085a.209.209 0 0 1 0-.376l2.661-2.086a.204.204 0 0 1 .3.184v1.865Z", fill: "currentColor" }), h("path", { key: '15c5179dc2591d2e84ea95dbad77ed144f5e1a52', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M2 4.5a.5.5 0 0 1 .5-.5h17a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-.5.5h-17a.5.5 0 0 1-.5-.5v-13Zm16.5 12v-11h-15v11h15Z", fill: "currentColor" }))));
    }
};
GravityIconAssetRecapVideo.style = GravityIconAssetRecapVideoStyle0;

export { GravityIconAssetRecapVideo as gravity_icon_asset_recap_video };

//# sourceMappingURL=gravity-icon-asset-recap-video.entry.js.map